var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"v-if":_vm.jinroGame}},[(_vm.gameMasterMessage)?_c('div',{staticClass:"m-b-10"},[_c('b-notification',{attrs:{"message":_vm.gameMasterMessage,"closable":false}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }